/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import React, { useState } from "react";
// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// react-router-dom components
//import { Link } from "react-router-dom";

// @mui material components
//import MuiLink from "@mui/material/Link";
// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";
import { TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
//import { Card, CardContent, TextField } from "@mui/material";
/* eslint-disable react/prop-types */
function RotatingCard({ color, image, title, description, add }) {
  const [idea, setIdea] = useState("");
  const [ideas, setIdeas] = useState([]);
  const [t] = useTranslation("common");
  const handleSubmit = () => {
    if (idea.trim()) {
      setIdeas([{ text: idea, votes: 0 }, ...ideas]);
      setIdea("");
      add(idea);
    }
  };
  /*const handleVote = (index) => {
    const updatedIdeas = [...ideas];
    updatedIdeas[index].votes++;
    setIdeas(updatedIdeas);
  };*/
  return (
    <MKBox
      display="flex"
      justifyContent="center"
      alignItems="center"
      borderRadius="lg"
      coloredShadow={color}
      bgColor="primary.dark"
      position="absolute"
      width="100%"
      height="100%"
      top={0}
      left={0}
      zIndex={5}
      sx={{
        backgroundImage: ({ palette: { gradients }, functions: { linearGradient, rgba } }) =>
          `${linearGradient(
            rgba(gradients[color] ? gradients[color].main : gradients.info.main, 0.3),
            rgba(gradients[color] ? gradients[color].main : gradients.info.main, 0.8)
          )}, url(${image})`,
        backgroundSize: "cover",
        backfaceVisibility: "hidden",
        transform: "rotateY(180deg)",
      }}
    >
      <MKBox pt={12} pb={2} px={2} textAlign="center" lineHeight={1}>
        <MKTypography variant="h3" color="white" gutterBottom>
          {title}
        </MKTypography>
        <MKTypography variant="body2" color="white" opacity={0.8}>
          {description}
        </MKTypography>
        <TextField
          label="Kirjoita tähän"
          multiline
          fullWidth
          minRows={3}
          value={idea}
          onChange={(e) => setIdea(e.target.value)}
          variant="outlined"
          style={{ marginBottom: "0.5rem", color: "#fff" }}
          InputLabelProps={{
            style: { color: "#fff" },
          }}
        />

        <MKButton variant="contained" onClick={handleSubmit}>
          {t("common.add")}
        </MKButton>
        <br />
        <br />
        {ideas.length === 0 && <MKTypography>{t("common.nosaved")}</MKTypography>}
      </MKBox>
    </MKBox>
  );
}

// Setting default props for the RotatingCard
RotatingCard.defaultProps = {
  color: "info",
};

// Typechecking props for the RotatingCard
RotatingCard.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "dark",
    "light",
  ]),
  image: PropTypes.string.isRequired,
  title: PropTypes.node.isRequired,
  description: PropTypes.node.isRequired,
  action: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.shape({
      type: PropTypes.oneOf(["external", "internal"]).isRequired,
      route: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ]).isRequired,
};

export default RotatingCard;
/**
 * 
 * {ideas.map((item, index) => (
          <Card key={index} style={{ marginBottom: "0.5rem", maxHeight: 200, overflow: "auto" }}>
            <CardContent
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <MKTypography>{item.text}</MKTypography>
            </CardContent>
          </Card>
        ))}
 */
